import { render } from "./Complaints.vue?vue&type=template&id=26cf5cda&scoped=true&ts=true"
import script from "./Complaints.vue?vue&type=script&lang=ts"
export * from "./Complaints.vue?vue&type=script&lang=ts"

import "./Complaints.vue?vue&type=style&index=0&id=26cf5cda&lang=scss&scoped=true"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26cf5cda"]])

export default __exports__